module.exports = __webpack_public_path__ + "static/media/subcon-app-logo.9568922c.png";